import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { TRANSITION_FUNCTION } from '../../../constants';

const TRANSITION_DURATION = 350;

const Styled = styled.div`
  position: relative;
  color: ${props => props.theme.colorMinor};
`;

const ValueBase = styled.span`
  will-change: transform;
`;

const Current = styled(ValueBase)`
  display: inline-block;
`;

const Next = styled(ValueBase)`
  position: absolute;
  top: 0;
  left: 0;
  transform: translateY(100%);
  opacity: 0;
`;

class ContactsRotator extends React.Component {
  static propTypes = {
    items: PropTypes.array.isRequired,
    delay: PropTypes.number.isRequired,
  };

  static defaultProps = {
    delay: 0,
  };

  timeout = 6000;

  state = {
    currentValue: '',
    nextValue: '',
  };

  componentDidMount() {
    this.showNext();

    setTimeout(() => {
      this.intervalId = setInterval(() => {
        this.showNext();
      }, this.timeout);
    }, this.props.delay);
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  showNext() {
    const nextValue = this.getRandom();
    this.setState({ nextValue }, () => {
      TweenMax.to(this.currentNode, 0.35, { y: '-100%', alpha: 0, ease: Power1.easeOut });
      TweenMax.fromTo(
        this.nextNode,
        0.35,
        { y: '100%', alpha: 0 },
        {
          y: '0%',
          alpha: 1,
          delay: 0.05,
          ease: Power1.easeOut,
          onComplete: () => {
            this.setState({ currentValue: nextValue, nextValue: '' }, () => {
              TweenMax.set(this.currentNode, { alpha: 1, y: '0%' });
            });
          },
        }
      );
    });
  }

  getRandom() {
    const items = this.props.items;
    const newValue = items[Math.floor(Math.random() * items.length)];
    if (items.length > 1 && newValue === this.state.currentValue) {
      return this.getRandom();
    }
    return newValue;
  }

  render() {
    return (
      <Styled data-test="rotator">
        <Current data-test="rotator-current" innerRef={node => (this.currentNode = node)}>
          {this.state.currentValue}
        </Current>
        <Next innerRef={node => (this.nextNode = node)}>{this.state.nextValue}</Next>
      </Styled>
    );
  }
}

export default ContactsRotator;



// WEBPACK FOOTER //
// ./src/scenes/Contacts/components/ContactsRotator.js